module.exports = __webpack_public_path__ + "img/def.419c4ab9.png";